import type { ServiceResponse } from "~/api/api.types";
import { useUsers } from "~/hooks";
import type { User } from "~/shared.types";
import { staffBookingPatientContextSchema } from "../utils/staff-booking-patient-schema";

const selectPatient = (response: ServiceResponse<User>) => ({
  user: response.data,
  context: staffBookingPatientContextSchema.parse(response.data),
});

export const useStaffBookingPatient = (userId: string | null) => {
  const { getUser } = useUsers();

  return getUser(userId ?? "", { select: selectPatient });
};
